// Kurye Sipariş Ayarları penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'couriers.orderSettings';

export const courierOrderSettingsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kurye sipariş ayarları nasıl yapılır?'),
  intro: t(`${G}.intro`, 'Bir kuryenin hangi şubeler için çalışacağını ve hangi tür siparişleri teslim edeceğini belirlersiniz. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık ve kurye adı'),
    body: t(`${G}.regions.body`, 'Şubeler ve sipariş türleri'),
    footer: t(`${G}.regions.footer`, 'İptal / Kaydet'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Kuryeyi kontrol edin'),
      text: t(`${G}.s1.text`, 'Başlıkta ve üstteki kartta ayarlarını değiştirdiğiniz kuryenin adı ile şu an bağlı olduğu şube ("Mevcut Şube") görünür.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Çalışacağı şubeleri seçin'),
      text: t(`${G}.s2.text`, '"Çalışacağı Şubeler" bölümünde "Şube ara ve ekle..." kutusuna şube adını yazıp listeden seçin; seçilen şube aşağıya yeşil etiket olarak eklenir. Birden fazla şube seçebilirsiniz. Bir şubeyi çıkarmak için etiketteki çarpıya basın.'),
      tips: [
        t(`${G}.s2.tip1`, 'En az bir şube seçmeden "Kaydet" düğmesi açılmaz.'),
        t(`${G}.s2.tip2`, 'Kurye, seçtiğiniz şubelerin kurye listesinde yer alır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Sipariş türlerini açıp kapatın'),
      text: t(`${G}.s3.text`, '"Sipariş Türü Ayarları" bölümünde kuryenin teslim edeceği türlerin anahtarını açık bırakın: "Restoran Siparişleri" (yemek ve içecek), "E-Ticaret Siparişleri" (online mağaza) ve "Paket Siparişleri" (kargo ve paket teslimatı).'),
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kaydedin'),
      text: t(`${G}.s4.text`, '"Kaydet" şube ve sipariş türü seçimlerini kuryenin kaydına yazar ve pencereyi kapatır. "İptal" değişiklikleri kaydetmeden kapatır.'),
    },
  ],
});
